(function () {
  function init() {
    var app = document.getElementById('taio-quiz-app');
    if (!app) return;

    var ALGI_URL    = 'https://taio.care/products/olej-z-alg';
    var SARDELA_URL = 'https://taio.care/products/olej-z-sardeli';

    var PRODUCTS = {};
    var prodEl = document.getElementById('qo-products');
    if (prodEl) { try { PRODUCTS = JSON.parse(prodEl.textContent); } catch (e) {} }

    var ICONS = {};
    var icoEl = document.getElementById('qo-icons');
    if (icoEl) { try { ICONS = JSON.parse(icoEl.textContent); } catch (e) {} }

    var Q = [
      {
        id: 1, tpl: false,
        text: 'Dla kogo szukasz oleju omega-3?',
        sub: null,
        answers: [
          { id: 'dog', text: 'Dla psa',  desc: null, a: 0, s: 0 },
          { id: 'cat', text: 'Dla kota', desc: null, a: 0, s: 0 }
        ]
      },
      {
        id: 2, tpl: true,
        text: 'Czy [A] jest uczulony na ryby?',
        answers: [
          { id: 'fish',      text: 'Tak, uczulony',        desc: 'Musi unika\u0107 sk\u0142adnik\u00f3w rybnych', oa: true, a: 0, s: 0 },
          { id: 'sensitive', text: 'Wra\u017cliwy brzuch', desc: 'Biegunki, gazy, nietolerancje',                          a: 2,    s: 0 },
          { id: 'no',        text: 'Bez problem\u00f3w',   desc: null,                                                      a: 0,    s: 0 },
          { id: 'unknown',   text: 'Nie wiem',             desc: null,                                                      a: 0,    s: 0 }
        ]
      },
      {
        id: 3, tpl: true,
        text: '[A] to...?',
        sub: null,
        answers: [
          { id: 'puppy',  text: 'Szczeni\u0119 / koci\u0119', a: 3, s: 0 },
          { id: 'adult',  text: 'Doros\u0142y', a: 0, s: 0 },
          { id: 'senior', text: 'Senior', a: 2, s: 0 }
        ]
      },
      {
        id: 4, tpl: false,
        text: 'Co chcesz wesprze\u0107?',
        sub: 'Wybierz to, co jest dla Ciebie najwa\u017cniejsze.',
        answers: [
          { id: 'joints',  text: 'Stawy',               desc: 'Regeneracja, komfort ruchu',       a: 0, s: 3 },
          { id: 'brain',   text: 'M\u00f3zg',            desc: 'Skupienie, uczenie, refleks',     a: 3, s: 0 },
          { id: 'coat',    text: 'Sier\u015b\u0107',    desc: 'Blask, mi\u0119kko\u015b\u0107',  a: 0, s: 0 },
          { id: 'general', text: 'Odporno\u015b\u0107',  desc: 'Profilaktyka, ogólne zdrowie',          a: 0, s: 0 }
        ]
      },
      {
        id: 5, tpl: true,
        text: 'Jak aktywny jest [A]?',
        sub: null,
        answers: [
          { id: 'high', text: 'Bardzo aktywny',           desc: 'Bieganie, sport',                               a: 0, s: 2 },
          { id: 'mid',  text: 'Przeci\u0119tnie',          desc: 'Codzienne spacery i zabawa',                    a: 0, s: 0 },
          { id: 'low',  text: 'Spokojny domator',          desc: 'Kr\u00f3tkie spacery, du\u017co le\u017cenia',  a: 0, s: 0 }
        ]
      },
      {
        id: 6, tpl: false,
        text: 'Co jest dla Ciebie wa\u017cne?',
        sub: null,
        answers: [
          { id: 'plant',         text: 'Bezpośrednie źródło omega-3', oa: true, a: 0, s: 0 },
          { id: 'concentration', text: 'Wysokie stężenie', a: 2,    s: 0 },
          { id: 'price',         text: 'Cena', a: 0,    s: 3 },
          { id: 'none',          text: 'Bez preferencji',      desc: null,                                       a: 0,    s: 0 }
        ]
      }
    ];

    var idx     = 0;
    var ans     = {};
    var phase   = 'quiz';
    var pending = null;

    function animal() {
      if (ans[1] === 'dog') return 'Tw\u00f3j pies';
      if (ans[1] === 'cat') return 'Tw\u00f3j kot';
      return 'Tw\u00f3j pupil';
    }
    function tpl(text) { return text.replace('[A]', animal()); }

    function findAnswer(q, id) {
      for (var i = 0; i < q.answers.length; i++) {
        if (q.answers[i].id === id) return q.answers[i];
      }
      return null;
    }

    function compute() {
      for (var i = 1; i <= 6; i++) {
        var r = findAnswer(Q[i - 1], ans[i]);
        if (r && r.oa) return 'algi';
      }
      var a = 0, s = 0;
      for (var j = 1; j <= 6; j++) {
        var r2 = findAnswer(Q[j - 1], ans[j]);
        if (r2) { a += r2.a || 0; s += r2.s || 0; }
      }
      return s > a ? 'sardela' : 'algi';
    }

    function collectReasons(pool, limit) {
      var out = [];
      for (var i = 0; i < pool.length && out.length < limit; i++) {
        if (pool[i].c) out.push(pool[i].t);
      }
      return out;
    }

    function algiReasons() {
      return collectReasons([
        { c: ans[2] === 'fish',          t: 'Nie zawiera sk\u0142adnik\u00f3w rybnych \u2014 bezpieczny przy alergii na ryby.' },
        { c: ans[2] === 'sensitive',     t: 'Ro\u015blinne \u017ar\u00f3d\u0142o omega-3 jest \u0142agodniejsze dla wra\u017cliwego uk\u0142adu pokarmowego.' },
        { c: ans[3] === 'puppy',         t: 'Wysoka koncentracja DHA (36%) wspiera prawid\u0142owy rozw\u00f3j m\u00f3zgu w pierwszym roku \u017cycia.' },
        { c: ans[3] === 'senior',        t: 'DHA wspiera funkcje poznawcze i zdrowie serca u senior\u00f3w \u2014 efekty widoczne po kilku tygodniach.' },
        { c: ans[4] === 'brain',         t: 'DHA to g\u0142\u00f3wny budulec neuron\u00f3w \u2014 olej z alg zawiera go wi\u0119cej ni\u017c jakikolwiek olej rybny.' },
        { c: ans[6] === 'plant',         t: 'Bezpośrednie \u017ar\u00f3d\u0142o \u2014 omega-3 prosto z alg morskich.' },
        { c: ans[6] === 'concentration', t: '62% EPA+DHA \u0142\u0105cznie \u2014 prawie dwa razy wy\u017csze st\u0119\u017cenie ni\u017c olej z sardeli.' },
        { c: true,                       t: 'Najwy\u017csze st\u0119\u017cenie EPA+DHA (62%) spo\u015br\u00f3d olej\u00f3w omega-3 dost\u0119pnych na rynku.' },
        { c: true,                       t: 'Produkowany z alg z certyfikowanych upraw w USA \u2014 bez ryzyka zanieczyszcze\u0144 morskich.' }
      ], 3);
    }

    function sardelaReasons() {
      return collectReasons([
        { c: ans[4] === 'joints', t: 'Wy\u017cszy poziom EPA \u2014 mniejszy stan zapalny w stawach i szybsza regeneracja chrz\u0105stki.' },
        { c: ans[5] === 'high',   t: 'EPA redukuje stany zapalne po wysi\u0142ku \u2014 kluczowe dla aktywnych ps\u00f3w i kot\u00f3w.' },
        { c: ans[3] === 'senior', t: 'Seniorzy korzystaj\u0105 z EPA dla staw\u00f3w i uk\u0142adu kr\u0105\u017cenia.' },
        { c: ans[6] === 'price',  t: '99 z\u0142 za 250 ml \u2014 ten sam standard jako\u015bci, przyst\u0119pniejsza cena.' },
        { c: true,                t: 'Dzika sardela z Oceanu Spokojnego \u2014 kr\u00f3tki \u0142a\u0144cuch pokarmowy, minimalne ryzyko metali ci\u0119\u017ckich.' },
        { c: true,                t: 'Korzystny stosunek EPA:DHA wspiera serce, stawy i regeneracj\u0119.' }
      ], 3);
    }

    var CHECK_SVG = '<svg width="8" height="6" viewBox="0 0 8 6" fill="none"><path d="M1 3L3 5L7 1" stroke="#EDF060" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var BACK_SVG  = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 13L5 8L10 3" stroke="rgba(255,255,255,0.8)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var CHECK_BIG = '<svg width="16" height="13" viewBox="0 0 16 13" fill="none"><path d="M1.5 6.5L5.5 10.5L14.5 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function getIcon(qIdx, answerId) { return ICONS['q' + (qIdx + 1) + '_' + answerId] || ''; }
    function hasAnyIcon(qIdx, answers) {
      for (var i = 0; i < answers.length; i++) { if (getIcon(qIdx, answers[i].id)) return true; }
      return false;
    }
    function gridClass(n) {
      if (n === 2) return 'qo-answers--grid-2';
      if (n === 3) return 'qo-answers--grid-3';
      return 'qo-answers--grid-4';
    }

    /* Continuous progress bar */
    function progressHtml(step, total) {
      var pct = Math.round((step / total) * 100);
      return '<div class="qo-top">'
        + '<div class="qo-top-meta"><span class="qo-count">' + step + '/' + total + '</span></div>'
        + '<div class="qo-progress-track"><div class="qo-progress-fill" style="width:' + pct + '%"></div></div>'
        + '</div>';
    }

    function render() {
      pending = null;
      if (phase === 'quiz')         renderQuiz();
      else if (phase === 'loading') renderLoading();
      else                          renderResult();
    }

    function renderQuiz() {
      var q       = Q[idx];
      var txt     = q.tpl ? tpl(q.text) : q.text;
      var useGrid = hasAnyIcon(idx, q.answers);
      var count   = q.answers.length;

      var answersHtml = '';
      for (var j = 0; j < count; j++) {
        var a    = q.answers[j];
        var icon = getIcon(idx, a.id);
        if (useGrid) {
          answersHtml += '<button class="qo-answer--card" data-id="' + a.id + '">'
            + '<div class="qo-card-icon">' + (icon ? '<img src="' + icon + '" alt="" loading="lazy">' : '') + '</div>'
            + '<span class="qo-card-label">' + esc(a.text) + '</span>'
            + (a.desc ? '<span class="qo-card-desc">' + esc(a.desc) + '</span>' : '')
            + '</button>';
        } else {
          answersHtml += '<button class="qo-answer--row" data-id="' + a.id + '">'
            + '<span class="qo-row-label">' + esc(a.text) + '</span>'
            + (a.desc ? '<span class="qo-row-desc">' + esc(a.desc) + '</span>' : '')
            + '</button>';
        }
      }

      var wrapCls = useGrid ? 'qo-answers--grid ' + gridClass(count) : 'qo-answers--list';

      app.innerHTML = ''
        + progressHtml(idx + 1, 6)
        + '<div class="qo-main">'
        +   '<div class="qo-card">'
        +     '<p class="qo-question">' + txt + '</p>'
        +     (q.sub ? '<p class="qo-sub">' + esc(q.sub) + '</p>' : '')
        +     '<div class="' + wrapCls + '">' + answersHtml + '</div>'
        +   '</div>'
        + '</div>'
        + '<div class="qo-bottom">'
        +   '<button class="qo-back' + (idx === 0 ? ' qo-back--hidden' : '') + '" id="qo-back-btn">' + BACK_SVG + '</button>'
        +   '<button class="qo-next" id="qo-next-btn">Dalej \u2192</button>'
        + '</div>';

      document.getElementById('qo-back-btn').addEventListener('click', goBack);
      document.getElementById('qo-next-btn').addEventListener('click', goNext);

      var btns = app.querySelectorAll('.qo-answer--card, .qo-answer--row');
      for (var k = 0; k < btns.length; k++) btns[k].addEventListener('click', onAnswer);
    }

    function renderLoading() {
      app.innerHTML = ''
        + progressHtml(6, 6)
        + '<div class="qo-loading-wrap">'
        +   '<div class="qo-spinner"></div>'
        +   '<p class="qo-loading-text">Analizujemy Twoje odpowiedzi\u2026</p>'
        + '</div>';
      setTimeout(function () { phase = 'result'; render(); }, 1600);
    }

    function renderResult() {
      var isAlgi = compute() === 'algi';
      var prod   = isAlgi ? PRODUCTS.algi : PRODUCTS.sardela;

      var p = isAlgi
        ? { name: 'Olej Omega-3 z Alg', sub: 'Ro\u015blinne omega-3 o najwy\u017cszym st\u0119\u017ceniu',
            url: ALGI_URL, altName: 'Olej z Sardeli Peruwiańskiej', altUrl: SARDELA_URL, reasons: algiReasons() }
        : { name: 'Olej z Sardeli Peruwiańskiej', sub: 'EPA-dominuj\u0105cy olej z dzikich ryb',
            url: SARDELA_URL, altName: 'Olej Omega-3 z Alg', altUrl: ALGI_URL, reasons: sardelaReasons() };

      var imgHtml   = prod && prod.image ? '<img src="' + prod.image + '" alt="' + esc(p.name) + '" loading="lazy">' : '';
      var priceHtml = prod && prod.price ? esc(prod.price) : (isAlgi ? '139 z\u0142' : '99 z\u0142');

      var reasonsHtml = '';
      for (var i = 0; i < p.reasons.length; i++) {
        reasonsHtml += '<div class="qo-reason"><div class="qo-reason-icon">' + CHECK_SVG + '</div><p class="qo-reason-text">' + esc(p.reasons[i]) + '</p></div>';
      }

      app.innerHTML = ''
        + '<div class="qo-result-wrap">'
        +   '<div class="qo-reco-badge"><div class="qo-reco-dot"></div><span class="qo-reco-label">Rekomendacja TAiO</span></div>'
        +   '<div class="qo-result-card">'
        +     '<div class="qo-product-hero">'
        +       '<div class="qo-product-img-wrap">' + imgHtml + '</div>'
        +       '<div class="qo-product-info">'
        +         '<p class="qo-product-name">' + esc(p.name) + '</p>'
        +         '<p class="qo-product-sub">' + esc(p.sub) + '</p>'
        +         '<span class="qo-product-price">' + priceHtml + '</span>'
        +       '</div>'
        +     '</div>'
        +     '<div class="qo-reasons"><p class="qo-why-title">Dlaczego w\u0142a\u015bnie ten?</p>' + reasonsHtml + '</div>'
        +     '<button class="qo-atc" id="qo-atc-btn" data-variant="' + (prod ? prod.variant_id : '') + '" data-price="' + priceHtml + '">Dodaj do koszyka \u2014 ' + priceHtml + '</button>'
        +     '<a class="qo-product-link" href="' + p.url + '">Zobacz pe\u0142n\u0105 stron\u0119 produktu \u2192</a>'
        +     '<div class="qo-divider"></div>'
        +     '<p class="qo-crosssell">Ciekawi Ci\u0119 te\u017c <a href="' + p.altUrl + '">' + esc(p.altName) + '</a>? Oba oleje TAiO spe\u0142niaj\u0105 te same standardy czysto\u015bci.</p>'
        +     '<p class="qo-disclaimer">Quiz ma charakter informacyjny. Oba oleje TAiO s\u0105 bezpieczne i skuteczne dla ps\u00f3w i kot\u00f3w.</p>'
        +   '</div>'
        +   '<button class="qo-reset" id="qo-reset-btn">Zr\u00f3b quiz jeszcze raz</button>'
        + '</div>';

      document.getElementById('qo-atc-btn').addEventListener('click', addToCart);
      document.getElementById('qo-reset-btn').addEventListener('click', resetQuiz);
    }

    function onAnswer(e) {
      var btn = e.currentTarget;
      var id  = btn.getAttribute('data-id');
      var all = app.querySelectorAll('.qo-answer--card, .qo-answer--row');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('qo-answer--selected');
      btn.classList.add('qo-answer--selected');
      pending = id;
      var nextBtn = document.getElementById('qo-next-btn');
      if (nextBtn) nextBtn.classList.add('qo-next--active');
      clearTimeout(window._qoTimer);
      window._qoTimer = setTimeout(function () { advance(id); }, 380);
    }

    function goNext() { if (!pending) return; clearTimeout(window._qoTimer); advance(pending); }

    function advance(id) {
      ans[idx + 1] = id;
      if (idx < Q.length - 1) { idx++; render(); }
      else { phase = 'loading'; render(); }
    }

    function goBack() { clearTimeout(window._qoTimer); if (idx > 0) { idx--; render(); } }
    function resetQuiz() { idx = 0; ans = {}; phase = 'quiz'; pending = null; render(); }

    function addToCart() {
      var btn       = document.getElementById('qo-atc-btn');
      var variantId = btn ? parseInt(btn.getAttribute('data-variant'), 10) : 0;
      var price     = btn ? btn.getAttribute('data-price') : '';
      if (!variantId || !btn) return;
      btn.disabled  = true;
      btn.innerHTML = '<div class="qo-atc-spinner"></div>';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        btn.innerHTML = CHECK_BIG + ' Dodano do koszyka';
        btn.classList.add('qo-atc--success');
        btn.disabled  = false;
        document.dispatchEvent(new CustomEvent('cart:open'));
        var c = document.querySelector('a[href="/cart"], button[aria-label*="Cart"], button[aria-label*="Kosz"]');
        if (c) c.click();
      })
      .catch(function () { btn.disabled = false; btn.innerHTML = 'Dodaj do koszyka \u2014 ' + price; });
    }

    function esc(s) {
      if (!s) return '';
      return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    render();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();